import type { RecordAccessRequestItem } from "../../services/record.service";

export const ACCESS_REQUEST_STATUS_LABELS: Record<
  RecordAccessRequestItem["status"],
  string
> = {
  Pending: "Bekliyor",
  Approved: "Onaylandı",
  Rejected: "Reddedildi",
};

export const accessRequestStatusLabel = (
  status: RecordAccessRequestItem["status"],
): string => ACCESS_REQUEST_STATUS_LABELS[status] ?? status;

export const accessRequestStatusChipColor = (
  status: RecordAccessRequestItem["status"],
): "warning" | "success" | "error" | "default" => {
  switch (status) {
    case "Pending":
      return "warning";
    case "Approved":
      return "success";
    case "Rejected":
      return "error";
    default:
      return "default";
  }
};

export function formatInviteStatusLabel(
  inviteStatus: { revoked: boolean; revoked_at?: string | null; has_active_invite: boolean } | null,
): string {
  if (!inviteStatus) return "—";
  if (inviteStatus.revoked) {
    return `İptal edildi${
      inviteStatus.revoked_at
        ? ` (${new Date(inviteStatus.revoked_at).toLocaleString("tr-TR")})`
        : ""
    }`;
  }
  return inviteStatus.has_active_invite ? "Aktif" : "Aktif değil";
}
